import { render, staticRenderFns } from "./Trendingtopicnew.vue?vue&type=template&id=3625808c&scoped=true"
import script from "./Trendingtopicnew.vue?vue&type=script&lang=js"
export * from "./Trendingtopicnew.vue?vue&type=script&lang=js"
import style0 from "./Trendingtopicnew.vue?vue&type=style&index=0&id=3625808c&prod&scoped=true&lang=css"
import style1 from "./Trendingtopicnew.vue?vue&type=style&index=1&id=3625808c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625808c",
  null
  
)

export default component.exports